import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import content from '../../content';
import './Experience.css';

const { experience } = content;

function Experience() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, offset: 80 });
  }, []);

  return (
    <section id={experience.id} className="experience-section">
      <div className="experience-container">
        {experience.label && (
          <div className="section-label" data-aos="fade-up">{experience.label}</div>
        )}
        <h2 className="section-heading" data-aos="fade-up" data-aos-delay="50">
          {experience.heading}
        </h2>

        <div className="timeline">
          {experience.entries.map((entry, i) => (
            <div
              key={`${entry.role}-${entry.company}`}
              className="timeline-item"
              data-aos={i % 2 === 0 ? 'fade-right' : 'fade-left'}
              data-aos-delay={i * 80}
            >
              <div className="timeline-dot" />
              <div className="timeline-card">
                <div className="timeline-card-top">
                  <div>
                    <h3 className="exp-role">{entry.role}</h3>
                    {entry.company && <p className="exp-company">{entry.company}</p>}
                  </div>
                  <div className="exp-meta">
                    {entry.type && <span className="exp-type">{entry.type}</span>}
                    {entry.period && <span className="exp-period">{entry.period}</span>}
                  </div>
                </div>
                {entry.description && (
                  <p className="exp-description">{entry.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
